@if (projectId$ | async; as projectId) {
<app-add-edit-team [newProject]="true" [projectId]="projectId" (Submit)="goToFacilities()"></app-add-edit-team>
}
